/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "446")




export interface API50751Req {
  
  /** 主键id */
  linkId?: number;
};



export interface API50751Res {
  /**   */
  code?: string;
  /**   */
  msg?: string;
  /**   */
  success?: boolean;
  /** data  */
  data?: boolean;
  /**   */
  exceptionMsg?: string;
  
};


// 50751 取消关联任务

export interface IUsePostAPI50751Return {
  /** 取消关联任务: 接口请求状态 */
  isAPI50751Loading: boolean;
  /** 取消关联任务: 接口请求返回数据 */
  dataAPI50751: API50751Res;
  /**  取消关联任务: 接口数据请求方法 */
  fetchAPI50751Data:  (inputs: API50751Req, config?: YWRequestConfig) => Promise<API50751Res>;
  /** 取消关联任务: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI50751 = ():IUsePostAPI50751Return => {
  let isMount = true;
  const [isAPI50751Loading, setIsAPI50751Loading] = useState(false);
  const [dataAPI50751, setDataAPI50751] = useState<API50751Res>({} as API50751Res);
  const requestUrl = `${basePath}/team-work/workTask/link/cancel`;

  const fetchAPI50751Data = async (inputs: API50751Req, config?: YWRequestConfig): Promise<API50751Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API50751Req>) || {}) as API50751Req;
    
  
    if ( isMount ) {
      setIsAPI50751Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API50751Res>(`${basePath}/team-work/workTask/link/cancel`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI50751(res || {} as API50751Res);
        setIsAPI50751Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI50751Loading(false);
      }
      return false as unknown as API50751Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI50751Loading,
    dataAPI50751,
    fetchAPI50751Data,
    requestUrl,
  }
}

